module.exports = __webpack_public_path__ + "img/share_tag_05.96ce3adf.png";